import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const API_DESPACHO = import.meta.env.VITE_API_DESPACHO;

const normalizeOptions = (items = []) => items.map((item) => ({
    ...item,
    value: item.value ?? item.id ?? item.name ?? item.text,
    label: item.label ?? item.text ?? item.name ?? item.id ?? item.value,
}));

const ScheduleAttendanceService = {
    list: async (filters = {}) => axios.post(`${API_DESPACHO}/schedule-attendance/list`, filters)
        .then(({data}) => data.data)
        .catch((err) => { throw err }),

    get: async (id = null) => axios.get(`${API_DESPACHO}/schedule-attendance${id ? `/${id}` : ""}`)
        .then(({data}) => data)
        .catch((err) => { throw err }),

    save: async (data) => axios.post(`${API_DESPACHO}/schedule-attendance`, data)
        .then(({data}) => data)
        .catch((err) => { throw err }),

    update: async (id, data) => axios.post(`${API_DESPACHO}/schedule-attendance/${id}`, data)
        .then(({data}) => data)
        .catch((err) => { throw err }),

    destroy: async (id) => axios.delete(`${API_DESPACHO}/schedule-attendance/${id}`)
        .then(({data}) => data)
        .catch((err) => { throw err }),

    getAttendanceProcedure: async (id) => axios.get(`${API_DESPACHO}/reasons/getAttendanceProcedure/${id}`)
        .then(({data}) => data)
        .catch((err) => { throw err }),

    sectors: async () => axios.get(`${API_DESPACHO}/places/sectors`)
        .then(({data}) => normalizeOptions(data.map(item => ({value: item.name ?? item.id ?? item.value, label: item.name ?? item.text ?? item.label}))))
        .catch(() => axios.get(`${API_URL}/despacho/getAttendanceSectors`)
            .then(({data}) => normalizeOptions(data))
            .catch((err) => { throw err })),

    attachmentUrl: (id) => `${API_DESPACHO}/attachment/get/${id}`,
};

export default ScheduleAttendanceService;
